import { useRef } from 'react';

export const workAreaPanelsGridClassName =
  'work-area-panels-grid grid min-h-0 w-full flex-1 grid-cols-[45fr_55fr] items-stretch gap-6 overflow-x-hidden px-4 pb-4 max-[599px]:grid-cols-1 max-[599px]:grid-rows-[minmax(14rem,1fr)_minmax(18rem,1fr)] max-[599px]:overflow-y-auto';

export const workAreaPanelClassName =
  'work-area-panel flex h-full min-h-0 min-w-0 w-full flex-col border border-gray-300';

/** Company panel — first when stacked below 600px viewport width. */
export const workAreaCompanyPanelClassName = `${workAreaPanelClassName} work-area-company-panel max-[599px]:min-h-[14rem]`;

/** Users panel — second row below company tree below 600px viewport width. */
export const workAreaUsersPanelClassName = `${workAreaPanelClassName} work-area-users-panel max-[599px]:min-h-[18rem]`;

/** Users: grid keeps filter on row 1 (title truncates); stacks with company when grid is narrow. */
export const workAreaPanelHeaderClassName =
  'work-area-users-panel__header grid w-full shrink-0 grid-cols-[minmax(0,1fr)_auto] items-center gap-x-3 gap-y-1.5 bg-[#233843] px-4 py-2';

export const workAreaPanelTitleClassName =
  'work-area-users-panel__title m-0 min-w-0 overflow-hidden text-ellipsis whitespace-nowrap text-sm font-medium leading-5 text-white';

export const workAreaPanelActionsClassName =
  'work-area-users-panel__actions flex shrink-0 flex-nowrap items-center justify-start justify-self-end';

/** Company tree: same grid header layout as users; stacks when grid is narrow. */
export const workAreaCompanyPanelHeaderClassName =
  'work-area-company-panel__header grid w-full shrink-0 grid-cols-[minmax(0,1fr)_auto] items-center gap-x-3 gap-y-1.5 bg-[#233843] px-4 py-2';

export const workAreaCompanyPanelTitleClassName =
  'work-area-company-panel__title m-0 min-w-0 overflow-hidden text-ellipsis whitespace-nowrap text-sm font-medium leading-5 text-white';

export const workAreaCompanyPanelActionsClassName =
  'work-area-company-panel__actions flex shrink-0 flex-nowrap items-center justify-start justify-self-end gap-x-2';

export const workAreaCompanyClearButtonClassName =
  '!m-0 !h-8 !min-h-8 !max-h-8 shrink-0 py-0 !pb-0';

export const workAreaFilterDropdownClassName =
  'work-area-panel-filter k-picker-solid !h-8 !min-h-8 !max-h-8 !w-[200px] !min-w-0 !max-w-[200px] shrink [&_.k-input-inner]:!overflow-visible [&_.k-input-value-text]:!overflow-visible [&_.k-input-value-text]:!whitespace-nowrap';

export const workAreaPanelBodyClassName =
  'relative min-h-0 flex-1 overflow-x-auto overflow-y-auto bg-white';

/** Ref for the flex-grown panels grid (panels use h-full + flex-1 body for tree height). */
export const useWorkAreaPanelsGridRef = () => {
  const ref = useRef<HTMLDivElement>(null);
  return { panelsGridRef: ref };
};
